import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppJoin from "./AppJoin";
import AppFormPage from "./AppFormPage";
import AppLayout from './AppLayout';
import Play from "components/Room/Play"

export default class AppView extends Component {
    static displayName = AppView.name;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        if (params.has("clearapp")) {
            localStorage.removeItem("IsAppView");
            window.location.href = "/";
        }
    }

    render() {
        return (
                <AppLayout>
                    <React.Fragment>
                        <Routes>
                            <Route path={"/"} key={'page-1'} element={<AppFormPage><AppJoin /></AppFormPage>} />;
                            <Route path={"/App"} key={'page-1'} element={<AppFormPage><AppJoin /></AppFormPage>} />;
                            <Route path={"/join"} key={'page-1'} element={<AppFormPage><AppJoin /></AppFormPage>} />;
                            <Route path={"/App/play"} key={'page-2'} element={<Play />} />;
                        </Routes>
                    </React.Fragment>
                </AppLayout>
        );
    }
}
